import React, {useState, useEffect, useRef} from 'react';
import Loading from './../loading';
import Error from './../error';
import ParseQueries from './../../actions/parseQueries';
import { Alert, Table, Input, Spinner, Form, FormGroup, Label } from 'reactstrap';
import AddPermissionModal from './addPermissionModal';
import ParseUser from './../../actions/parseUser';
import * as AppConfig from './../../constants/AppConfig';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import './permissionList.css';
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import Auth from './../../actions/auth';

const EN = {
    // Options.jsx
    items_per_page: '/ page',
    jump_to: 'Go to ',
    page: '',
  
    // Pagination.jsx
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
  }

const PERMISSIONS = ['admin', 'moderator', 'suspended', 'remove'];  //TODO: Add custom TS spawning back in; add member back to list

export default class PermissionList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            loading: [],
            error: '',
            memberships: null,
            membershipsCount: 0,
            page: 1,
            ascending: true,
            sortField: 'permission'
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        let roomSecurity = this.props.roomSecurity;
        if(!roomSecurity) {
            this.setState({isLoading: false, error: 'Missing room security object'});
        } else if(!roomSecurity.get('account')) {
            this.setState({isLoading: false, error: `To use this feature please complete the form in the Account tab`});
        } else {
            this.getMembershipsAndCount();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.page !== this.state.page || prevState.sortField !== this.state.sortField || prevState.ascending !== this.state.ascending) {
            this.fetchMemberships();
        }
        if(prevProps.roomSecurity !== this.props.roomSecurity) {
            this.getMembershipsAndCount()
        }
    }

    getMembershipsAndCount = async () => {
        try {
            this.setState({isLoading: true});
            let roomSecurity = this.props.roomSecurity;
            let [memberships, count] = await Promise.all([ParseQueries.getMembers(roomSecurity.get('account'), this.state.page, ['owner', 'admin', 'moderator', 'member', 'suspended']), ParseQueries.getTotalMembersCount(roomSecurity.get('account'), ['owner', 'admin', 'moderator', 'suspended'])]);
            if(this._isMounted) {
                this.setState({isLoading: false, memberships, membershipsCount: count});
            }
        } catch(error) {
            if(this._isMounted) {
                this.setState({isLoading: false, error: error.message});
            }
        }
    }

    fetchMemberships = async () => {
        try {
            this.setState({isLoading: true});
            let roomSecurity = this.props.roomSecurity;
            let memberships = await ParseQueries.getMembers(roomSecurity.get('account'), this.state.page, ['owner', 'admin', 'moderator', 'member', 'suspended'], {'field': this.state.sortField, 'ascending': this.state.ascending});
            if(this._isMounted) {
                this.setState({isLoading: false, memberships});
            }
        } catch(error) {
            if(this._isMounted) {
                this.setState({isLoading: false, error: error.message});
            }
        }
    }

    updateSelect = async (e) => {
        let memberships = [...this.state.memberships];
        let index = e.target.attributes['index'].value;
        let prevPermission = memberships[index].get('permission');
        memberships[index].set('permission', e.target.value);
        this.setState({memberships});
        try {
            await this.updateMembership(memberships[index], e.target.value);
        } catch(error) {
            if(this._isMounted) {
                memberships[index].set('permission', prevPermission);
                this.setState({memberships});
            }
        }
    }

    updateMembership = (membership, permission) => {
        return new Promise( async (resolve, reject) => {
            try {
                if(permission === 'remove') {
                    this.setState({loading: this.state.loading.concat([membership.id])});
                    await ParseUser.removeMembership(membership);
                    if(this._isMounted) {
                        let loadingList = [...this.state.loading];
                        loadingList.splice(loadingList.indexOf(membership.id), 1);
                        this.setState({loading: loadingList});
                        this.fetchMemberships();
                    }
                } else if(permission === 'admin' || permission === 'moderator' || permission === 'member' || permission === 'suspended') {
                    this.setState({loading: this.state.loading.concat([membership.id])});
                    let updatedMembership = await ParseUser.updateUserMembership(membership, {'permission': permission});
                    if(this._isMounted) {
                        let loadingList = [...this.state.loading];
                        loadingList.splice(loadingList.indexOf(membership.id), 1);
                        this.setState({loading: loadingList});
                        resolve(updatedMembership);
                    }
                } else {
                    throw new Error('Permission not found');
                }
            } catch(error) {
                let loadingList = [...this.state.loading];
                loadingList.splice(loadingList.indexOf(membership.id), 1);
                this.setState({loading: loadingList});
                reject(error);
            }
        });
    }

    renderMembers = (memberships) => {
        return memberships.map( (membership, idx) => {
            return(
                <tr key={'member' + idx}>
                    <td>{membership.get('email')}</td>
                    <td className='center'>{membership.get('displayname') || 'pending...'}</td>
                    <td className='center'>
                        {(this.state.loading.includes(membership.id))? (<Spinner size='sm' color='primary'/>) : (
                            <Input type='select' id='permissionSelect' value={membership.get('permission')} index={idx} disabled={!!membership.get('user') && (membership.get('user').id === this.props.ownerId || membership.get('user').id === Auth.getCurrentUser().id)} onChange={this.updateSelect}>
                                <option>{membership.get('permission')}</option>
                                {PERMISSIONS.filter(perm => perm !== membership.get('permission')).map( (perm, idx) => {
                                    if(!membership.get('user') && (perm !== 'remove')) return null;
                                    return <option key={'permissions_'+idx}>{perm}</option>
                                })}
                            </Input>
                        )}
                    </td>
                </tr>
            );
        });
    }

    renderTable = (memberships) => {
        if(!memberships.length) {
            return (
                <Alert color='warning' className='center'>No users found</Alert>
            );
        } else {
            return (
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th className='hover'><span id='email' onClick={this.updateSorting}>{this.tableHeaderText('Email')}</span></th>
                            <th className='center hover'><span id='display_name' onClick={this.updateSorting}>{this.tableHeaderText('Displayname')}</span></th>
                            <th className='center hover'><span id='permission' onClick={this.updateSorting}>{this.tableHeaderText('Permission')}</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderMembers(memberships)}
                    </tbody>
                </Table>
            );
        }
    }

    tableHeaderText(fieldName) {
        let caret = null;
        const dict = {'Permission': 'permission', 'Displayname': 'display_name', 'Email': 'email'};
        if(this.state.sortField === dict[fieldName]) {
            if(!this.state.ascending) {
                caret = (
                    <IoIosArrowUp />
                )
            } else {
                caret = (
                    <IoIosArrowDown />
                );
            }
        }
        return (
            <React.Fragment>
                {fieldName}{caret}
            </React.Fragment>
        );
    }

    updateSorting = (e) => {
        if(e.target.id === this.state.sortField) {
            this.setState({ascending: !this.state.ascending});
        } else {
            this.setState({sortField: e.target.id});

        }
    }

    paginationChange = (pageNumber) => {
        this.setState({page: pageNumber});
    }

    render() {
        //TODO: Add custom TS spawning back in
        // let accountId = this.props.roomSecurity.get('subscription').get('account').id;

        if(this.state.isLoading) {
            return (
                <Loading />
            );
        } else if(!!this.state.error) {
            return (
                <Error color='warning' message={this.state.error} />
            );
        } else {
            let memberships = this.state.memberships;
            return (
                <React.Fragment>
                    {/* {(!(accountId === 'tOKUGcsdJ2' || accountId === 'QfmSO4ZeAN')) && <CustomSpawnSettings roomSecurity={this.props.roomSecurity} updateRoomSecurities={this.props.updateRoomSecurities}/>} */}
                    {this.renderTable(memberships)}
                    <div className='center'>
                        <Pagination simple locale={EN} showQuickJumper={{ goButton: <button>Go</button> }} defaultCurrent={this.state.page} defaultPageSize={AppConfig.default.Pagination} total={this.state.membershipsCount} onChange={this.paginationChange}/>
                    </div>
                    {this.props.isOpen && <AddPermissionModal isOpen={this.props.isOpen} toggle={this.props.toggleModal} roomSecurity={this.props.roomSecurity} update={this.fetchMemberships}/>}
                </React.Fragment>
            );
        }
    }
}

// eslint-disable-next-line
function CustomSpawnSettings({roomSecurity, updateRoomSecurities}) {
    let [{customSpawn, disableGoto}, updateState] = useState({
        customSpawn: !!roomSecurity.get('directAccess'),
        disableGoto: (!!roomSecurity.get('permissions'))? !!roomSecurity.get('permissions')['disableGoto'] : false
    });
    let [isLoading, setLoading] = useState(false);
    const didMount = useRef(false);

    useEffect(() => {
        async function updateRs(roomSecurity) {
            if(didMount.current) {
                let permissions = roomSecurity.get('permissions') || {};
                setLoading(true);
                let rs = await roomSecurity.save({
                    directAccess: customSpawn,
                    permissions: {...permissions, disableGoto}
                });
                setLoading(false);
                updateRoomSecurities(rs);
            } else {
                didMount.current = true;
            }
        }
        updateRs(roomSecurity);
    }, [customSpawn, disableGoto, didMount, updateRoomSecurities]);

    function handleSpawnSettings(e) {
        let id = e.target.id;
        let checked = e.target.checked;
        if(id === 'customSpawn' && !checked && disableGoto) {   //Can't disable goto without spawning in TS
            updateState(state => ({...state, [id]: checked, disableGoto: false}));
        } else if(id === 'disableGoto' && checked && !customSpawn) {
            updateState(state => ({...state, [id]: checked, customSpawn: true}));
        } else {
            updateState(state => ({...state, [id]: checked}));
        }
    }

    return <Form className='permission-checkboxes'>
        <FormGroup check inline>
            <Label check><Input type="checkbox" id='customSpawn' onChange={handleSpawnSettings} disabled={isLoading} checked={customSpawn}/> Start Here</Label>
        </FormGroup>
        <FormGroup check inline>
            <Label check><Input type="checkbox" id='disableGoto' onChange={handleSpawnSettings} disabled={isLoading} checked={disableGoto}/> Disable Menu</Label>
        </FormGroup>
    </Form>
}